exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-outline-secondary[data-v-bfd05530]{color:#6a6969}.btn-outline-secondary[data-v-bfd05530]:hover{color:#f7f7f7;background-color:#6a6969;border-color:#6a6969}.hidden[data-v-bfd05530]{opacity:0}.speech-bubble-tooltip[data-v-bfd05530]{background:#f7f7f7;border-radius:.4em;padding:15px 10px;font-size:24px;color:#6a6969;float:left;bottom:24px;left:-45px;min-width:300px;z-index:100000}.speech-bubble-tooltip[data-v-bfd05530]:after{content:\"\";position:absolute;bottom:0;left:45px;width:0;height:0;border:20px solid transparent;border-top-color:#f7f7f7;border-bottom:0;margin-left:-20px;margin-bottom:-20px;z-index:100000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bfd05530","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/general/help-bottom-left.vue
// module id = 1955
// module chunks = 0